if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      
        onVariantChangeUnsubscriber = undefined;
        abortController = undefined;
        pendingRequestUrl = null;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];

        constructor() {
            super();                        
        }

        connectedCallback() {
            this.initializeProductSwapUtility();
            const html = document.querySelector('html');            
            const variant = this.getSelectedVariant(html);

            this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.optionValueSelectionChange,
                this.handleOptionValueChange.bind(this)
            );

            this.updateMedia(html, variant?.featured_media?.id);

            this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        }


        addPreProcessCallback(callback) {
            this.preProcessHtmlCallbacks.push(callback);
        }

        disconnectedCallback() {
            this.onVariantChangeUnsubscriber();
        }

        initializeProductSwapUtility() {
        
        
            this.preProcessHtmlCallbacks.push((html) =>
            html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
            );
            this.postProcessHtmlCallbacks.push((newNode) => {
            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
            });
        }

        handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {

            
            if (!this.contains(event.target)) return;

            this.resetProductFormState();


            const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;


            
            this.pendingRequestUrl = productUrl;
            const shouldSwapProduct = this.dataset.url !== productUrl;

            
            const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
            
            
            this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
            targetId: target.id,
            callback: shouldSwapProduct
                ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
                : this.handleUpdateProductInfo(productUrl),
            });
        }

        resetProductFormState() {
            const productForm = this.productForm;

            this.submitButton = this.querySelector('[name="add"]');
            productForm?.toggleSubmitButton(true);

        } 

        handleSwapProduct(productUrl, updateFullPage) {
            
            
            return (html) => {
            //this.productModal?.remove();
            

            const selector = updateFullPage ? "product-info[id^='product--template']" : 'product-info';

            const variant = this.getSelectedVariant(html.querySelector(selector));

            this.updateURL(productUrl, variant?.id);


            if (updateFullPage) {                
                document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

                
                HTMLUpdateUtility.viewTransition(
                document.querySelector('main'),
                html.querySelector('main'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
                );

            } else {

                HTMLUpdateUtility.viewTransition(
                this,
                html.querySelector('product-info'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
                );
            }
            };
        }

        renderProductInfo({ requestUrl, targetId, callback }) {        
            
            

            this.abortController?.abort();
            this.abortController = new AbortController();


            fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(responseText, 'text/html');                                  
                callback(html);
            })
            .then(() => {
                // set focus to last clicked option value                
                document.querySelector(`#${targetId}`)?.focus();
            })
            .catch((error) => {
                if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
                } else {
                console.error(error);
                }
            });
        }

        getSelectedVariant(productInfoNode) {

            const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;

            return !!selectedVariant ? JSON.parse(selectedVariant) : null;
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
            const params = [];

            !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);



            if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
            }
            

            return `${url}?${params.join('&')}`;
        }

        updateOptionValues(html) {
            const variantSelects = html.querySelector('variant-selects');
            
            if (variantSelects) {
            HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
            
            }
        }
        toggleAddButton(disable = true, text, modifyClass = true) {
            
            const productForm = document.getElementById(`product-form-${this.dataset.section}`);
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const buttonsContainer = productForm.querySelector(".shopiy-payment-buttons-container");
            const payButton = buttonsContainer.querySelector('[data-shopify="payment-button"]');
            const payButtons = payButton && payButton.querySelectorAll("button");
            const addButtonText = addButton.querySelector('[name="add"] .add-to-cart-content');

            if (!addButton) return;
            if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            buttonsContainer.classList.add('hidden');
            payButton && payButton.classList.add('hidden');
            if (text) addButtonText.textContent = text;
            } else {
            addButton.removeAttribute('disabled');
            buttonsContainer.classList.remove('hidden');
            payButton && payButton.classList.remove('hidden');
            addButtonText.textContent = window.variantStrings.addToCart;
            }

            if (!modifyClass) return;
        }

        updateInventory(html) {
            const id = `stock-inventory-${this.dataset.section}`;
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
        
            if (source && destination) destination.innerHTML = source.innerHTML;
        }

        handleUpdateProductInfo(productUrl) {

            return (html) => {
            
            const variant = this.getSelectedVariant(html);

            this.pickupAvailability?.update(variant);
            this.updateOptionValues(html);

            this.updateURL(productUrl, variant?.id);
            this.updateVariantInputs(variant?.id);

            if (!variant) {
                this.setUnavailable();
                return;
            }

            
            this.updateMedia(html, variant?.featured_media?.id);


            const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
                const source = html.getElementById(`${id}-${this.sectionId}`);
                const destination = this.querySelector(`#${id}-${this.dataset.section}`);
                
                if (source && destination) {
                destination.innerHTML = source.innerHTML;
                destination.classList.toggle('hidden', shouldHide(source));
                }
            };

            updateSourceFromDestination('price');
            updateSourceFromDestination('sku');
            updateSourceFromDestination('stock-inventory', ({ innerText }) => innerText === '');


            this.productForm?.toggleSubmitButton(
                html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
                window.variantStrings.soldOut
            );


            publish(PUB_SUB_EVENTS.variantChange, {data: {
            sectionId: this.sectionId,
            html,
            variant: variant
            }});
            };
        }

        updateVariantInputs(variantId) {
            this.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
            ).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            const errorMessage = productForm.querySelector('#product_form-error');
            if(errorMessage && !errorMessage.classList.contains("hidden")) errorMessage.classList.add('hidden')
            
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }

        updateURL(url, variantId) {
            this.querySelector('share-button')?.updateUrl(
            `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
            );
            if (this.dataset.updateUrl === 'false') return;
            window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
        }

        setUnavailable() {
                this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

                const selectors = ['price', 'stock-inventory']
                .map((id) => `#${id}-${this.dataset.section}`)
                .join(', ');
                document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
                }

        handleErrorMessage(errorMessage = false) {
            if (this.hideErrors) return;

            this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
            }
        }

        toggleSubmitButton(disable = true, text) {
            
            if (disable) {
            this.submitButton?.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
            } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
            }
        }

        updateMedia(html, variantFeaturedMediaId) {
 

        if (!variantFeaturedMediaId) return;

        
        const mediaGallerySource = this.querySelector('media-gallery #images-slider');

        const variant_id = `${ this.sectionId }-${ this.getSelectedVariant(html).featured_media.id }`
        
        const selected_element = [...mediaGallerySource.children].find((slide)=>{
            return slide.dataset.mediaId === variant_id        
        });    

        if (!selected_element) return; 
        
        this.mediaGallery.sliderScroll(selected_element.getAttribute('data-image'))
        
        }

        get productForm() {
            return this.querySelector(`product-form`);
        }

        get mediaGallery() {
            return this.querySelector(`media-gallery`);
        }

        get productModal() {
            return document.querySelector(`#ProductModal-${this.dataset.section}`);
        }

        get pickupAvailability() {
            return this.querySelector(`pickup-availability`);
        }

        get variantSelectors() {
            return this.querySelector('variant-selects');
        }

        get relatedProducts() {
            const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'related-products'
            );
            return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
        }

        get quickOrderList() {
            const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'quick_order_list'
            );
            return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
        }

        get sectionId() {
            return this.dataset.originalSection || this.dataset.section;
        }
    }
  );
}
